module.exports = __webpack_public_path__ + "static/media/stampa_medie.ecda5a3c.png";